const baseUrl: string = process.env.REACT_APP_API_URL || '';

class Applications {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });
}

export default new Applications('/auth/v1/application');



// WEBPACK FOOTER //
// ./src/libraries/api/application.tsx